<template>
  <div class="text-left">
    <div class="row">
      <div class="col-sm-3">
        <h3 class="font-weight-bolder mt-3">Rapid/PCR Test</h3>
      </div>
      <div class="col col-sm-2 pt-3">
        <template v-if="crew.active == 1">
        <AddPcrRapidTest v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline"></AddPcrRapidTest>
        </template>
      </div>

      <div class="col col-sm-12">
        <MedicalNavigation></MedicalNavigation>
      </div>

      <div class="col-sm-12">
        <table
            class="table table-sm table-hover table-bordered text-small text-center"
            style="border-color: lightgray;"
        >
          <thead class="bg-lightgray">
          <tr>
            <th width="2%">#</th>
            <th width="10%">Test Type</th>
            <th width="10%">Place Conducted</th>
            <th width="15%">Country/Airport/Port/Vessel</th>
            <th width="10%">Lab/Hospital</th>
            <th width="10%">Other Hospital/Lab</th>
            <th width="7%">Date Conducted</th>
            <th width="7%">Date Result</th>
            <th width="6%">Result</th>
            <th width="5%">Days to Expire</th>
            <th width="10%">Action</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(crewPcrRapidTest, index) in crewPcrRapidTests"
              :key="crewPcrRapidTest.id"
          >
            <td class="align-middle">{{ index + 1 }}</td>
            <td class="align-middle">
              {{ crewPcrRapidTest.crew_covid_test_type.name }}
            </td>
            <td class="align-middle">
              {{ crewPcrRapidTest.crew_covid_test_conducted_place.name }}
            </td>
            <td class="align-middle">
              {{ crewPcrRapidTest.conducted_place_sub }}
            </td>
            <td class="align-middle">
              {{
                crewPcrRapidTest.crew_covid_test_country_hospital
                    ? crewPcrRapidTest.crew_covid_test_country_hospital.name
                    : "N/A"
              }}
            </td>
            <td class="align-middle">
              {{
                crewPcrRapidTest.others
                    ? crewPcrRapidTest.others
                    : "N/A"
              }}
            </td>
            <td class="align-middle">
              {{ crewPcrRapidTest.formatted_conducted_date }}
            </td>
            <td class="align-middle">
              {{ crewPcrRapidTest.formatted_result_date }}
            </td>
            <td
                class="align-middle"
                :class="{
                  'text-danger font-weight-bold':
                    crewPcrRapidTest.crew_covid_test_type_result.is_positive_result,
                }"
            >
              {{ crewPcrRapidTest.crew_covid_test_type_result.name }}
            </td>
            <td
                class="align-middle"
                :class="{
                  'text-danger font-weight-bold':
                    crewPcrRapidTest.days_to_expire <= 15 || 'Expired',
                }"
            >
              {{ crewPcrRapidTest.days_to_expire }}
            </td>
            <td class="align-middle">
              <button
                  class="btn btn-sm btn-xs btn-outline-info"
                  data-toggle="modal"
                  data-target="#view-crew-medical"
                  @click="setEditable(crewPcrRapidTest)"
              >
                <span class="fas fa-file-alt"></span>
                View
              </button>
              <template v-if="crew.active == 1 || isSystemAdmin">
                <button v-if="(isDesignatedManning || isPrincipalStaff) && !guest && !isKline"
                        class="btn btn-sm btn-xs btn-outline-danger ml-1"
                        @click="deleteCrewPcrRapidTest(crewPcrRapidTest.id)"
                >
                  <span class="fas fa-ban"></span>
                  Delete
                </button>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- view modal start -->
      <div
          class="modal fade px-2"
          id="view-crew-medical"
          tabindex="-1"
          role="dialog"
      >
        <div
            class="modal-dialog modal-dialog-centered modal-xxl"
            role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="view">View Medical Record</h5>
              <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close-update-crew-medical"
                  @click="editable = false"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-small">
              <div class="row">
                <form
                    class="col-4 form-group"
                    @submit.prevent="updateCrewPcrRapidTest"
                >
                  <table class="col-table-2 table-sm w-100">
                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="test_type"
                        >
                          Test Type:
                        </label>
                      </th>
                      <td>
                        <select
                            id="test_type"
                            required
                            :disabled="!editable"
                            class="form-control form-control-sm"
                            v-model="editCrewPcrRapidTest.crew_covid_test_type_id"
                        >
                          <option :value="''" disabled>
                            --- Select Test Type ---
                          </option>
                          <option
                              v-for="covidTestType in covidTestTypes"
                              :key="covidTestType.id"
                              :value="covidTestType.id"
                          >
                            {{ covidTestType.name }}
                          </option>
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="conducted_place"
                        >
                          Place Conducted:
                        </label>
                      </th>
                      <td>
                        <select
                            :disabled="!editable"
                            class="form-control form-control-sm"
                            id="conducted_place"
                            v-model="
                            editCrewPcrRapidTest.crew_covid_test_conducted_place_id
                          "
                            @change="toggleCrewPcrRapidOtherHospital"
                        >
                          <option :value="''">
                            --- Select Place Conducted ---
                          </option>
                          <option
                              v-for="conductedPlace in conductedPlaces"
                              :key="conductedPlace.id"
                              :value="conductedPlace.id"
                          >
                            {{ conductedPlace.name }}
                          </option>
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="country"
                        >
                          Country/Airport/Port/Vessel:
                        </label>
                      </th>
                      <td>
                        <select
                            class="form-control form-control-sm"
                            v-show="
                            !editCrewPcrRapidTest.crew_covid_test_conducted_place_id
                          "
                            :disabled="
                            !editCrewPcrRapidTest.crew_covid_test_conducted_place_id
                          "
                            id="country"
                        ></select>

                        <select
                            v-if="
                            editCrewPcrRapidTest.crew_covid_test_conducted_place_id ===
                              1
                          "
                            class="form-control form-control-sm"
                            id="country"
                            :disabled="!editable"
                            v-model="
                            editCrewPcrRapidTest.crew_covid_test_country_id
                          "
                            @change="
                            fetchCrewCovidCountryHospitals(
                              editCrewPcrRapidTest.crew_covid_test_country_id
                            );
                            toggleCrewPcrRapidOtherHospital();
                          "
                        >
                          <option :value="''">--- Select Country ---</option>
                          <option
                              v-for="country in countries"
                              :key="country.id"
                              :value="country.id"
                          >{{ country.name }}
                          </option
                          >
                        </select>

                        <select
                            v-if="
                            editCrewPcrRapidTest.crew_covid_test_conducted_place_id ===
                              2 ||
                              editCrewPcrRapidTest.crew_covid_test_conducted_place_id ===
                                4
                          "
                            class="form-control form-control-sm"
                            id="country"
                            :disabled="!editable"
                            v-model="editCrewPcrRapidTest.port_id"
                            @change="
                            fetchCrewCovidCountryHospitals(
                              editCrewPcrRapidTest.crew_covid_test_country_id
                            )
                          "
                        >
                          <option :value="''">--- Select Port ---</option>
                          <option
                              v-for="ports in ports"
                              :key="ports.id"
                              class="text-uppercase"
                              :value="ports.id"
                          >{{ ports.name }}
                          </option
                          >
                        </select>

                        <input
                            type="text"
                            :disabled="!editable"
                            id="country"
                            v-if="
                            editCrewPcrRapidTest.crew_covid_test_conducted_place_id ===
                              3
                          "
                            class="form-control form-control-sm"
                            :value="currentCrewActivity.name"
                            readonly
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="hospital"
                        >
                          Hospital/Lab:
                        </label>
                      </th>
                      <td>
                        <input
                            v-if="editable && !isCrewPcrRapidTestHospitalRequired"
                            id="date_conducted"
                            type="text"
                            class="form-control form-control-sm"
                            readonly
                            disabled
                        />

                        <select
                            v-else
                            :disabled="
                            !editable ||
                              editCrewPcrRapidTest.crew_covid_test_conducted_place_id !=
                                1
                          "
                            class="form-control form-control-sm"
                            id="hospital"
                            v-model="
                            editCrewPcrRapidTest.crew_covid_test_country_hospital_id
                          "
                        >
                          <option :value="''">
                            --- Select Hospital/Lab ---
                          </option>
                          <option
                              v-for="countryHospital in countryHospitals"
                              :key="countryHospital.id"
                              :value="countryHospital.id"
                          >{{ countryHospital.name }}
                          </option
                          >
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="others"
                        >
                          Other Hospital/Lab:
                        </label>
                      </th>
                      <td>
                        <input
                            v-if="editable && editCrewPcrRapidTest.crew_covid_test_country_hospital_id && countryHospitals"
                            id="date_result"
                            class="form-control form-control-sm"
                            type="text"
                            readonly
                            disabled
                        />

                        <input
                            v-else
                            type="text"
                            id="others"
                            class="form-control form-control-sm"
                            :disabled="!editable"
                            v-model="editCrewPcrRapidTest.others"
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="date_conducted"
                        >
                          Date Conducted:
                        </label>
                      </th>
                      <td>
                        <input
                            :disabled="!editable"
                            type="date"
                            id="date_conducted"
                            class="form-control form-control-sm"
                            v-model="editCrewPcrRapidTest.conducted_date"
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="date_result"
                        >
                          Date Result:
                        </label>
                      </th>
                      <td>
                        <input
                            :disabled="!editable"
                            type="date"
                            id="date_result"
                            class="form-control form-control-sm"
                            v-model="editCrewPcrRapidTest.result_date"
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            for="result"
                        >
                          Result:
                        </label>
                      </th>
                      <td>
                        <select
                            :disabled="!editable"
                            id="result"
                            class="form-control form-control-sm"
                            v-model="
                            editCrewPcrRapidTest.crew_covid_test_type_result_id
                          "
                        >
                          <option :value="''">--- Select Result ---</option>
                          <option
                              v-for="covidTestTypeResult in covidTestTypeResults"
                              :key="covidTestTypeResult.id"
                              :value="covidTestTypeResult.id"
                          >{{ covidTestTypeResult.name }}
                          </option
                          >
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <th>
                        <label
                            class="font-weight-bolder text-left form-label-sm"
                            :disabled="!editable"
                            for="attachment"
                        >
                          Upload File:
                        </label>
                      </th>
                      <td>
                        <input
                            type="file"
                            id="edit_attachment"
                            :disabled="!editable"
                            accept="application/pdf"
                            @change="updateFileFrame"
                        />
<!--                        <div class="custom-file">-->
<!--                          <div id="crewMedicalContainer">-->
<!--                            <input-->
<!--                                :disabled="!editable"-->
<!--                                type="file"-->
<!--                                class="custom-file-input"-->
<!--                                id="edit_attachment"-->
<!--                                accept="application/pdf"-->
<!--                                @change="updateFileFrame"-->
<!--                            />-->
<!--                          </div>-->
<!--                          <label class="custom-file-label" for="attachment">-->
<!--                            Choose file-->
<!--                          </label>-->
<!--                        </div>-->
                      </td>
                    </tr>
                    <tr v-if="(isDesignatedManning || isPrincipalStaff) && !guest">
                      <td></td>
                      <td class="text-right">
                        <template v-if="crew.active == 1 || isSystemAdmin">
                          <button
                              type="submit"
                              class="btn btn-warning btn-sm mr-3 font-weight-bolder"
                          >
                            <i class="fas fa-edit"></i>
                            {{ editable ? "Update" : "Edit" }}
                          </button>
                        </template>
                        <button
                            class="btn btn-danger btn-sm font-weight-bolder"
                            v-if="editable"
                            @click="cancelEdit"
                        >
                          <span class="fas fa-ban"></span>
                        </button>
                      </td>
                    </tr>
                  </table>
                </form>

                <div class="col-8 pb-0 bg-lightgray">
                  <iframe
                      id="newFileFrame"
                      :src="uploadedFile"
                      v-if="uploadedFile"
                      height="600"
                      width="910"
                  />
                  <div class="alert alert-warning" role="alert" v-else>
                    NO UPLOADED DOCUMENT
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- view modal end -->
    </div>
  </div>
</template>

<script>
import {GlobalService} from "@/services/GlobalService";
import Swal from "sweetalert2";
import {mapActions, mapGetters, mapState} from "vuex";
import AddPcrRapidTest
  from "@/components/sub_components/master_lists/crews/crew_show_components/documents/medicals/AddPcrRapidTest";
import ViewPcrRapidTest
  from "@/components/sub_components/master_lists/crews/crew_show_components/documents/medicals/ViewPcrRapidTest";
import MedicalNavigation
  from "@/components/sub_components/master_lists/crews/crew_show_components/documents/medicals/MedicalNavigation";
import {gateMixin} from "@/mixins/gateMixin";
import {FileService} from "@/services/FileService";

export default {
  name: "PcrRapidTest",
  mixins: [gateMixin],

  components: {AddPcrRapidTest, MedicalNavigation},
  data() {
    return {
      medicalId: "",
      editable: false,
      editCrewPcrRapidTest: {
        id: null,
        crew_id: null,
        crew_covid_test_type_id: null,
        crew_covid_test_conducted_place_id: null,
        crew_covid_test_type_result_id: null,
        conducted_date: null,
        result_date: null,
        crew_covid_test_country_hospital_id: null,
        port_id: null,
        crew_covid_test_country_id: null,
        remarks: null,
        others: null,
      },
      isCrewPcrRapidTestHospitalRequired: false,
      uploadedFile: null,
      tempEdit:{},
    };
  },
  methods: {

    ...mapActions(['getPortKeys']),

    async fetchCrewPcrRapidTests() {
      this.$store.dispatch(
          "CrewCovidTestModule/fetchCrewPcrRapidTests",
          this.crew.id
      );
    },

    async fetchCrewPcrRapidTestPdf(crewPcrRapidTestId) {
      return this.$store.dispatch(
          "CrewCovidTestModule/fetchCrewPcrRapidTestPdf",
          crewPcrRapidTestId
      );
    },

    async deleteCrewPcrRapidTest(id) {
      let self = this;

      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          self.$store
              .dispatch("CrewCovidTestModule/deleteCrewPcrRapidTest", id)
              .then(() => {
                self.fetchCrewPcrRapidTests();
              });
        }
      });
    },

    setEditable(crewPcrRapidTest) {
      this.uploadedFile = null;
      this.editCrewPcrRapidTest = Object.assign({},crewPcrRapidTest);
      this.tempEdit=Object.assign({},crewPcrRapidTest)
      this.fetchCrewCovidTestTypeResult(
          this.editCrewPcrRapidTest.crew_covid_test_type_id
      );
      this.fetchCrewPcrRapidTestPdf(this.editCrewPcrRapidTest.id).then((res) => {
        this.uploadedFile = "data:application/pdf;base64," + res.data.pdf;
      });
    },

    updateFileFrame() {
      let input = document.getElementById("edit_attachment");

      if (input.files && input.files[0]) {
        if (input.files[0].size > 1000000) {
          document.getElementById("prompt-alert").innerText = "FILE TOO LARGE";
          this.clearIframe();
          this.withUploadedFile = false;
          return;
        } else {
          this.clearIframe();
          document.getElementById("prompt-alert").innerText = "";
          let reader = new FileReader();
          reader.onload = function (e) {
            document.getElementById("newFileFrame").src =
                e.target.result + "#zoom=80";
          };
          reader.readAsDataURL(input.files[0]);
          this.withUploadedFile = true;
        }
      }
    },

    clearIframe() {
      document.getElementById("newFileFrame").src = "";
    },

    async fetchConductedPlaces() {
      this.$store.dispatch(
          "CrewCovidTestConductedPlaceModule/fetchConductedPlaces"
      );
    },

    async fetchCrewCovidTypes() {
      this.$store.dispatch("CrewCovidTestTypeModule/fetchTypes");
    },

    updateCrewPcrRapidTest() {

      if (!this.editable) {
        this.editable = true;
        this.toggleCrewPcrRapidOtherHospital();
        return;
      }

      let formData = new FormData();

      Object.keys(this.editCrewPcrRapidTest).forEach((key) => {
        if (key === "test_type") {
          let value = this.editCrewPcrRapidTest[key] === "pcr" ? 1 : 0;
          formData.append("is_pcr", value);
        } else {
          let value = this.editCrewPcrRapidTest[key]
              ? this.editCrewPcrRapidTest[key]
              : "";
          formData.append(key, value);
        }
      });

      let attachment = document.getElementById("edit_attachment");

      if (attachment.files && attachment.files[0]) {
        let file = attachment.files[0];
        formData.append("attachment", file);
      }

      this.$store
          .dispatch("CrewCovidTestModule/updateCrewPcrRapidTest", {
            data: formData,
            id: this.editCrewPcrRapidTest.id,
          })
          .then(() => {
            this.fetchCrewPcrRapidTests();
            Swal.fire({
              title: "Upload",
              text: "Crew PCR/Rapid Test Successfully Updated.",
              type: "success",
              timer: 2000,
            });
            document.getElementById('edit_attachment').value = "";
            document.getElementById("close-update-crew-medical").click();
          })
          .catch(error => {
            return GlobalService.handleError(error, 'updateCrewPcrRapidTest');
          });
    },

    fetchCrewCovidTestTypeResult(crewCovidTestType) {
      this.$store.dispatch(
          "CrewCovidTestTypeResultModule/fetchTypeResults",
          crewCovidTestType
      );
    },

    fetchCrewCovidCountry() {
      this.$store.dispatch("CrewCovidTestCountryModule/fetchCountries");
    },

    fetchCrewCovidCountryHospitals(countryId) {
      this.$store.dispatch(
          "CrewCovidTestCountryHospitalModule/fetchCountryHospitals",
          countryId
      );
    },

    cancelEdit() {
      this.editable = false;
      this.editCrewPcrRapidTest=Object.assign({},this.tempEdit)
      this.fetchCrewCovidTestTypeResult(
          this.editCrewPcrRapidTest.crew_covid_test_type_id
      );
      this.fetchCrewPcrRapidTestPdf(this.editCrewPcrRapidTest.id).then((res) => {
        if(res.data.pdf) this.uploadedFile=false;
        this.uploadedFile =FileService.base64FileToBlobUrl("data:application/pdf;base64," + res.data.pdf);
      });
    },

    fetchPort() {
      this.$store.dispatch("PortModule/getPortKeys");
    },

    fetchCurrentCrewActivity() {
      this.$store.dispatch(
          "CurrentCrewActivityModule/fetchCurrentCrewActivity",
          this.crew.id
      );
    },

    toggleCrewPcrRapidOtherHospital() {
      let country = this.countries.find(
          (country) =>
              country["id"] == this.editCrewPcrRapidTest.crew_covid_test_country_id
      );

      if (!country) {
        return;
      }

      this.isCrewPcrRapidTestHospitalRequired = country["is_hospital_required"];
    },
  },

  created() {
    this.fetchCrewPcrRapidTests();
    this.fetchConductedPlaces();
    this.fetchCrewCovidTypes();
    this.fetchCrewCovidTestTypeResult();
    this.fetchCrewCovidCountry();
    this.fetchCrewCovidCountryHospitals();
    this.fetchCurrentCrewActivity();

    if (!this.ports.length) {
      this.getPortKeys();
    }
  },

  computed: {
    ...mapState({
      crew: (state) => {
        return state.CrewModule.crew;
      },
      crewPcrRapidTests: (state) => {
        return state.CrewCovidTestModule.crewPcrRapidTests;
      },
      crewPcrRapidTestPdf: (state) => {
        return state.CrewCovidTestModule.pdf;
      },
      conductedPlaces: (state) => {
        return state.CrewCovidTestConductedPlaceModule.conductedPlaces;
      },
      covidTestTypes: (state) => {
        return state.CrewCovidTestTypeModule.types;
      },
      covidTestTypeResults: (state) => {
        return state.CrewCovidTestTypeResultModule.typeResults;
      },
      countries: (state) => {
        return state.CrewCovidTestCountryModule.countries;
      },
      countryHospitals: (state) => {
        return state.CrewCovidTestCountryHospitalModule.countryHospitals;
      },
      ports: (state) => {
        return state.PortModule.portKeys;
      },
      currentCrewActivity: (state) => {
        return state.CurrentCrewActivityModule.currentCrewActivity;
      },
    }),
  },
  watch:{
    'editCrewPcrRapidTest.crew_covid_test_country_hospital_id'(){
      if(this.editCrewPcrRapidTest.crew_covid_test_country_hospital_id){
        this.editCrewPcrRapidTest.others=null;
      }
    }
  }
};
</script>

<style scoped>
* {
  font-family: "Nunito", sans-serif;
}

.bg-lightgray {
  background: lightgray;
}

.col-table-2 tr td:first-child {
  font-weight: bold;
}

.modal-lg {
  max-width: 1000px;
}
</style>
